export default[
  {"value":"Mr.","id":1},
  {"value":"Ms.","id":2},
  {"value":"Miss","id":3},
  {"value":"Mrs.","id":4},
  {"value":"Dr.","id":5},
  {"value":"Prof.","id":6},
  {"value":"Rev.","id":7},
  {"value":"Monsignor","id":8},
  {"value":"Honourable","id":9},
  {"value":"Father","id":10},
  {"value":"Brother","id":11},
  {"value":"Sister","id":12},
  {"value":"Pastor","id":13},
  {"value":"Rabbi","id":14},
  {"value":"Sir","id":15},
  {"value":"Madam","id":16},
  {"value":"Dame","id":17},
  {"value":"Lord","id":18},
  {"value":"Lady","id":19},
  {"value":"Ambassador","id":20},
  {"value":"Colonel","id":21},
  {"value":"Captain","id":22},
  {"value":"Admiral","id":23},
  {"value":"General","id":24},
];